import { useEffect } from "react";

export default function Seo({ title, siteName, description, image, jsonLd }) {
  useEffect(() => {
    const url = window.location.origin + window.location.pathname;
    const ensure = (sel, create) => {
      let el = document.head.querySelector(sel);
      if (!el) {
        el = create();
        document.head.appendChild(el);
      }
      return el;
    };
    const link = ensure('link[rel="canonical"]', () => {
      const l = document.createElement("link");
      l.setAttribute("rel", "canonical");
      return l;
    });
    link.setAttribute("href", url);
    const set = (attr, key, val) => {
      if (!val) return;
      const m = ensure(`meta[${attr}="${key}"]`, () => {
        const el = document.createElement("meta");
        el.setAttribute(attr, key);
        return el;
      });
      m.setAttribute("content", val);
    };
    set("property", "og:url", url);
    set("property", "og:type", "website");
    if (title) {
      document.title = title;
      set("property", "og:title", title);
      set("name", "twitter:title", title);
    }
    set("property", "og:site_name", siteName);
    if (description) {
      set("name", "description", description);
      set("property", "og:description", description);
      set("name", "twitter:description", description);
    }
    if (image) {
      const abs = image.startsWith("http") ? image : window.location.origin + image;
      set("property", "og:image", abs);
      set("name", "twitter:image", abs);
      set("name", "twitter:card", "summary_large_image");
    }
    if (jsonLd) {
      let script = document.head.querySelector("script[data-seo-jsonld]");
      if (!script) {
        script = document.createElement("script");
        script.setAttribute("type", "application/ld+json");
        script.setAttribute("data-seo-jsonld", "true");
        document.head.appendChild(script);
      }
      script.textContent = JSON.stringify(jsonLd);
    }
  }, [title, siteName, description, image, jsonLd]);
  return null;
}
